import {IconButton} from "../widgets/button/IconButton";
import type {AppState} from "../../data/state/AppState";
import {useAppStore} from "../../StateManager";
import {StringUtils} from "../../utils/data/string/StringUtils";

export const TopBarBackButton = () => {
	const appState: AppState = useAppStore((state) => state.appState);
	const navigation = appState.app.navigation;
	const {lastNonSettingsHash} = navigation;

	const onBackClick = () => {
		if (StringUtils.isHashValid(lastNonSettingsHash, appState.currentUIVersion, appState.user)) {
			navigation.go(lastNonSettingsHash);
		} else {
			navigation.goApp({
				organizationId: appState.organizationIdByAuthData,
				mainNav: appState.defaultMenu,
			});
		}
	};

	return (
		<IconButton
			icon="arrow"
			onClick={onBackClick}
		/>
	);
};
